import { ProtocolList } from '../enum'

// 链接跳转hook
const getLink = (link, id) => {
  const protocol = link.match(/^([a-zA-Z0-9]+\:\/\/)/ig)[0]
  let protocolConfig = {}
  ProtocolList.forEach(_protocol => {
    if (_protocol.header === protocol) {
      protocolConfig = _protocol
    }
  })
  let url = link
  if (protocolConfig.header) {
    url = protocol + id
  }
  return url
}

const linkTo = (link, id) => {
  const url = getLink(link, id)
  window.open(url, '_blank')
}

export {
  getLink,
  linkTo
}
